<script>
import { isEmpty } from 'lodash'
import PointForm from '@src/forms/Point'
import Request from '@src/mixins/request'

export default {
  $_veeValidate: { validator: 'new' },

  mixins: [Request],

  props: {
    propertyId: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      form: new PointForm(),
      color: 'gold',
      schema: PointForm.validator(),
    }
  },

  computed: {
    text() {
      if (isEmpty(this.item)) {
        return { heading: 'New Point', submit: 'Add' }
      }

      return { heading: 'Edit Point', submit: 'Update' }
    },
  },

  mounted() {
    this.form = new PointForm(this.item)
  },

  methods: {
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (isEmpty(this.item)) {
            this.addItem()
          } else {
            this.updateItem()
          }
        }
      })
    },
    addItem() {
      this.updateData({
        url: this.endpoint.point.add,
        data: {
          propertyId: this.propertyId,
          data: this.form,
        },
      }).then(() => {
        this.backToList()
      })
    },
    updateItem() {
      this.updateData({
        url: this.endpoint.point.update,
        data: {
          id: this.item.id,
          propertyId: this.propertyId,
          update: this.form,
        },
      }).then(() => {
        this.backToList()
      })
    },
    backToList() {
      this.$emit('event', { currentView: 'PointList' })
    },
  },
}
</script>

<template>
  <VForm @submit.prevent="onSubmit">
    <BaseView :title="text.heading" :color="color">
      <BaseControlInput label="Name">
        <VTextField
          v-model="form.name"
          v-validate="schema.name"
          data-vv-name="name"
          label="Name"
          :error-messages="errors.collect('name')"
          :color="color"
        />
      </BaseControlInput>

      <BaseControlInput label="Description">
        <VTextarea
          v-model="form.description"
          v-validate="schema.description"
          data-vv-name="description"
          label="Description"
          :error-messages="errors.collect('description')"
          :color="color"
        />
      </BaseControlInput>

      <BaseControlInput label="Point to reedem">
        <VTextField
          v-model="form.point"
          v-validate="schema.point"
          data-vv-name="point"
          label="Point to reedem"
          suffix="points"
          :error-messages="errors.collect('point')"
          :color="color"
        />
      </BaseControlInput>

      <BaseControlInput label="Valid from">
        <BaseDatePicker
          v-model="form.validFrom"
          v-validate="schema.validFrom"
          data-vv-name="from"
          label="Valid from"
          :error-messages="errors.collect('from')"
          :color="color"
        />
      </BaseControlInput>

      <BaseControlInput label="Valid to">
        <BaseDatePicker
          v-model="form.validTo"
          v-validate="schema.validTo"
          data-vv-name="to"
          label="Valid to"
          :error-messages="errors.collect('to')"
          :color="color"
        />
      </BaseControlInput>

      <template slot="card-actions-right">
        <VBtn
          depressed
          :disabled="loading"
          @click="$emit('event', { currentView: 'PointList' })"
        >
          Cancel
        </VBtn>

        <VBtn
          :color="color"
          :loading="loading"
          :disabled="!!errors.count()"
          type="submit"
          depressed
          :dark="!errors.count()"
        >
          {{ text.submit }}
        </VBtn>
      </template>
    </BaseView>
  </VForm>
</template>
